module.exports = __webpack_public_path__ + "./images/5c6cd10ed261e5f72a0686d96ab0110a.webp";